export default {
  en: {
    pageTitle: 'Select Time'
  },
  ja: {
    pageTitle: '予約時間選択'
  }
}
